function addPerformanceMark(label) {
  window.performance.mark(label);
}
function measurePerformanceMark(measureName, startMark, endMark) {
  if (!endMark) {
    window.performance.measure(measureName, startMark);
    const measures2 = window.performance.getEntriesByName(measureName);
    if (measures2.length === 0) {
      throw new Error(`Could not find measure with name=${measureName}`);
    }
    return measures2[measures2.length - 1].duration;
  }
  window.performance.measure(measureName, startMark, endMark);
  const measures = window.performance.getEntriesByName(measureName);
  if (measures.length === 0) {
    throw new Error(`Could not find measure with name=${measureName}`);
  }
  return measures[measures.length - 1].duration;
}
export {
  addPerformanceMark,
  measurePerformanceMark
};
